import React from "react";
import { createPortal } from "react-dom";
import { Edit, FileText, Plus, Trash2 } from "lucide-react";

export default function CounselingMobileTimelineOverlay({
  selectedStudent,
  studentLogs,
  onTouchStart,
  onTouchMove,
  onModalSwipeEnd,
  setSelectedStudentId,
  getTypeColor,
  getTypeIcon,
  canEditLog,
  handleEditStart,
  handleDeleteLog,
  theme,
  setIsCreatingLog,
}) {
  if (!selectedStudent) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] bg-[#F5F7F6] flex flex-col pb-[calc(56px+env(safe-area-inset-bottom))]"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={() => onModalSwipeEnd(() => setSelectedStudentId(null))}
    >
      <div className="flex-shrink-0 flex items-center justify-between px-4 bg-white z-50 pt-[calc(env(safe-area-inset-top)+36px)] pb-3 border-b border-gray-100 min-h-[50px]">
        <button onClick={() => setSelectedStudentId(null)} className="text-gray-500 font-bold text-base">
          뒤로
        </button>
        <h2 className="font-bold text-lg text-gray-900">{selectedStudent.name}</h2>
        <div className="w-10"></div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-4">
        {studentLogs.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-gray-300">
            <FileText size={48} className="mb-3 opacity-20" />
            <p className="text-sm font-medium">아직 기록이 없습니다</p>
          </div>
        ) : (
          <div className="space-y-3">
            {studentLogs.map((log) => {
              const colors = getTypeColor(log.type);
              const Icon = getTypeIcon(log.type);
              return (
                <div key={log.id} className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm">
                  <div className="flex items-start gap-3 mb-2">
                    <div className={`w-10 h-10 rounded-xl ${colors.bg} ${colors.text} flex items-center justify-center flex-shrink-0`}>
                      <Icon size={20} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between gap-2">
                        <span className={`text-xs font-bold ${colors.text}`}>{log.type}</span>
                        <span className="text-[10px] text-gray-400">{log.date}</span>
                      </div>
                      <p className="text-sm text-gray-700 font-medium mt-1 leading-relaxed">{log.content}</p>
                    </div>
                  </div>
                  <div className="flex justify-end gap-2 mt-2">
                    {canEditLog(log) && (
                      <>
                        <button onClick={() => handleEditStart(log)} className="text-gray-300 hover:text-[#354F38] hover:bg-green-50 p-1.5 rounded-full transition-all">
                          <Edit size={14} />
                        </button>
                        <button onClick={() => handleDeleteLog(log.id)} className="text-gray-300 hover:text-rose-500 hover:bg-rose-50 p-1.5 rounded-full transition-all">
                          <Trash2 size={14} />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <button
        onClick={() => setIsCreatingLog(true)}
        className={`absolute bottom-24 right-6 w-14 h-14 ${theme.bg} text-white rounded-full shadow-2xl flex items-center justify-center active:scale-95 transition-all z-[10001] ring-4 ring-white shadow-[0_10px_25px_-5px_rgba(0,0,0,0.1)]`}
      >
        <Plus size={28} strokeWidth={3} />
      </button>
    </div>,
    document.body
  );
}
